var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pr prompt"},[_c('img',{attrs:{"src":require("@/assets/Icons/tip.png"),"alt":""}}),_c('i',{class:['line-sm font14 font-light', {active: _vm.isMany}]},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }